import React from 'react';
import Icon from '../../../../components/Icon/Icon';
import { Typography, Stack } from '@mui/material';

const PRIORITY_CONFIG = {
  "STAT (Within 2 Hours)":                              { icon: 'fa-triangle-exclamation', color: 'error',   label: 'STAT' },
  "Urgent (Within 4 Hours)":                            { icon: 'fa-triangle-exclamation', color: 'warning', label: 'Urgent' },
  "Priority (Within 6 Hours)":                          { icon: 'fa-triangle-exclamation', color: 'yellow',  label: 'Priority' },
  "Routine (Same day if ordered before 3 PM local time)": { icon: 'fa-clock',              color: 'success', label: 'Routine' },
  "Standard (Within 24 Hours)":                         { icon: 'fa-clock',               color: 'primary', label: 'Standard' },
  "Coordination (Scheduled Date and Time)":             { icon: 'fa-calendar-days',        color: 'primary', label: 'Coordination' },
  "Drop Ship (Freight Times)":                          { icon: 'fa-plane',                color: 'primary', label: 'Dropship' },
};

const PriorityIcon = (priorityName) => {
  const config = PRIORITY_CONFIG[priorityName];
  if (!config) return null;

  return (
    <Stack direction="column" alignItems="center" gap={1}>
      <Icon icon={config.icon} size="md" color={config.color} />
      <Typography color="text.secondary" fontWeight="medium">
        {config.label}
      </Typography>
    </Stack>
  );
};


export default PriorityIcon;
